<template>
    <div class="mod">
        <upLoadImg :filesList="imgList" />
    </div>
</template>
<script>
    import upLoadImg from '@/components/upLoadImg.vue'
    
    export default {
        name: 'demo',
        components: {
            upLoadImg
        },
        data() {
            
            return {
                imgList: []
            }
        },
    }
</script>
<style lang="less" scoped>
    .mod {
        width: 100%;
        height: 100%;
    }
</style>
